import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
}), 'LayersSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LayersSharp.js
// module id = 4438
// module chunks = 2